import Overview from './overview.vue';
import MobOverview from './mob-overview.vue';

export const componentMap = {
	overview: Overview,
	'mob-overview': MobOverview
};
